
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "icon-circle-button";

@Component
export default class IconCircleButton extends Vue {
  @Prop({ type: String, default: null }) readonly icon: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;

  get classes() {
    const { disabled } = this;

    return {
      [`${CLASS}_disabled`]: disabled,
    };
  }
}
